import parse from 'html-react-parser'
import { sectionColour } from 'utils/sectionColour'

type Props = {
  howItWorksTitle?: string
  howItWorks?: string
  howItWorksTitle2?: string
  howItWorks2?: string
  howItWorksTitle3?: string
  howItWorks3?: string
  howItWorksTitle4?: string
  howItWorks4?: string
}

const PreviewCenteredContentPanel = ({
  howItWorksTitle,
  howItWorks,
  howItWorksTitle2,
  howItWorks2,
  howItWorksTitle3,
  howItWorks3,
  howItWorksTitle4,
  howItWorks4,
}: Props) => {
  const { backgroundColor, textColor, headingColor, borderColor } =
    sectionColour('branding')

  return (
    <section
      className={`${backgroundColor} px-9 py-20 lg:py-32 lg:px-24 section-border-grey`}
    >
      <div className="container mx-auto xl:px-12">
        <div className="mb-12 flex justify-center">
          <h2 className={`${headingColor} font-black`}>How it works</h2>
        </div>
        <div
          className={`${textColor} grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12`}
        >
          <div className={`${borderColor} col border-t border-opacity-70`}>
            <h3 className="mb-4 mt-6">{howItWorksTitle || 'Step one'}</h3>
            <p>
              {howItWorks ? parse(howItWorks) : 'Describe the first step here.'}
            </p>
          </div>
          <div className={`${borderColor} col border-t border-opacity-70`}>
            <h3 className="mb-4 mt-6">{howItWorksTitle2 || 'Step two'}</h3>
            <p>
              {howItWorks2 ? parse(howItWorks2) : 'Describe the second step.'}
            </p>
          </div>
          <div className={`${borderColor} col border-t border-opacity-70`}>
            <h3 className="mb-4 mt-6">{howItWorksTitle3 || 'Step three'}</h3>
            <p>
              {howItWorks3 ? parse(howItWorks3) : 'Describe the third step.'}
            </p>
          </div>
          <div className={`${borderColor} col border-t border-opacity-70`}>
            <h3 className="mb-4 mt-6">{howItWorksTitle4 || 'Step four'}</h3>
            <p>
              {howItWorks4 ? parse(howItWorks4) : 'Describe the fourth step.'}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PreviewCenteredContentPanel
